// axiosConfig.js - Configuration Axios avec intégration Sentry
import axios from 'axios';
import { captureSentryException, addSentryContext } from '../initSentry';

// Fonction générique pour créer une instance axios avec un intercepteur intégré et Sentry
const createAxiosInstance = (baseURL, serviceName = 'unknown') => {
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'fr'
        }
    });

    // Intercepteur de requête
    instance.interceptors.request.use(
        (config) => {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user && user.token) {
                    config.headers['Authorization'] = 'Bearer ' + user.token;
                }

                // Ajouter des métadonnées pour Sentry
                config.metadata = {
                    startTime: Date.now(),
                    service: serviceName,
                    url: config.url,
                    method: config.method?.toUpperCase()
                };

            } catch (error) {
                console.error('Error retrieving user from localStorage', error);
                captureSentryException(error, {
                    context: 'axios_request_interceptor',
                    service: serviceName
                });
            }
            return config;
        },
        (error) => {
            captureSentryException(error, {
                context: 'axios_request_error',
                service: serviceName
            });
            return Promise.reject(error);
        }
    );

    // Intercepteur de réponse
    instance.interceptors.response.use(
        (response) => {
            // Calculer le temps de réponse
            const responseTime = Date.now() - response.config.metadata?.startTime;

            // Ajouter des informations de performance à Sentry pour les requêtes lentes
            if (responseTime > 3000) { // Plus de 3 secondes
                addSentryContext('slow_request', {
                    service: serviceName,
                    url: response.config.url,
                    method: response.config.method,
                    responseTime: `${responseTime}ms`,
                    status: response.status
                });
            }

            return response;
        },
        (error) => {
            const config = error.config;
            const responseTime = config?.metadata ? Date.now() - config.metadata.startTime : null;

            // Contexte détaillé pour Sentry
            const context = {
                service: serviceName,
                url: config?.url || 'unknown',
                method: config?.method?.toUpperCase() || 'unknown',
                status: error.response?.status || 'no_response',
                responseTime: responseTime ? `${responseTime}ms` : 'unknown'
            };

            // Différents niveaux d'erreur selon le code de statut
            if (error.response) {
                // Erreur de réponse du serveur
                context.responseData = error.response.data;
                context.errorType = 'server_error';

                if (error.response.status >= 500) {
                    // Erreur serveur critique
                    captureSentryException(error, context);
                } else if (error.response.status === 401) {
                    // Erreur d'authentification - moins critique
                    context.errorType = 'auth_error';
                    captureSentryException(error, context);
                } else if (error.response.status >= 400) {
                    // Erreur client - informative
                    context.errorType = 'client_error';
                    captureSentryException(error, context);
                }
            } else if (error.request) {
                // Erreur de réseau
                context.errorType = 'network_error';
                captureSentryException(error, context);
            } else {
                // Autre erreur
                context.errorType = 'unknown_error';
                captureSentryException(error, context);
            }

            return Promise.reject(error);
        }
    );

    return instance;
};

// Création de plusieurs instances nommées avec identification du service
export const bankInstance = createAxiosInstance('https://parameter.ntrfinancial.com/bank', 'bank-service');
export const walletInstance = createAxiosInstance('https://parameter.ntrfinancial.com/wallet', 'wallet-service');
export const parameterInstance = createAxiosInstance('https://parameter.ntrfinancial.com/parameter', 'parameter-service');
export const userInstance = createAxiosInstance('https://user.ntrfinancial.com/user', 'user-service');
export const recipientInstance = createAxiosInstance('https://recipient.ntrfinancial.com/recipient', 'recipient-service');
export const transferInstance = createAxiosInstance('https://transfer.ntrfinancial.com/transfer', 'transfer-service');

/*
export const bankInstance = createAxiosInstance('https://parameter.stelotechconsultingdev.com/bank');
export const walletInstance = createAxiosInstance('https://parameter.stelotechconsultingdev.com/wallet');
export const parameterInstance = createAxiosInstance('https://parameter.stelotechconsultingdev.com/parameter');
export const appVersionInstance = createAxiosInstance('https://parameter.stelotechconsultingdev.com/appversion');
export const userInstance = createAxiosInstance('https://user.stelotechconsultingdev.com/user');
export const recipientInstance = createAxiosInstance('https://recipient.stelotechconsultingdev.com/recipient');
export const transferInstance = createAxiosInstance('https://transfer.stelotechconsultingdev.com/transfer');
*/













/*
export const bankInstance = createAxiosInstance('http://5.189.171.198:8085/bank');
export const walletInstance = createAxiosInstance('http://5.189.171.198:8085/wallet');
export const parameterInstance = createAxiosInstance('http://5.189.171.198:8085/parameter');
export const appVersionInstance = createAxiosInstance('http://5.189.171.198:8085/appversion');
export const userInstance = createAxiosInstance('http://5.189.171.198:8084/user');
export const recipientInstance = createAxiosInstance('http://5.189.171.198:8082/recipient');
export const transferInstance = createAxiosInstance('http://5.189.171.198:8083/transfer');
*/



/*
export const bankInstance = createAxiosInstance('http://localhost:8085/bank');
export const walletInstance = createAxiosInstance('http://localhost:8085/wallet');
export const parameterInstance = createAxiosInstance('http://localhost:8085/parameter');
export const appVersionInstance = createAxiosInstance('http://localhost:8085/appversion');
export const userInstance = createAxiosInstance('http://localhost:8084/user');
export const recipientInstance = createAxiosInstance('http://localhost:8082/recipient');
export const transferInstance = createAxiosInstance('http://localhost:8083/transfer');
*/
